<div class="layout-column full-height">

  <div class="layout-row layout-align-start-center routes-header padding-5">
    <!--    <app-bringoz-search-input class="flex"-->
    <!--                              [placeholder]="'Search Routes' | translate"-->
    <!--                              [query]="queryString"-->
    <!--                              (queryChangeEvent)="onQueryChange($event)">-->

    <!--    </app-bringoz-search-input>-->

    <app-visit-plan-resource-holders-multi-select
      class="flex-40"
      [visitPlanId]="visitPlan.id"
      [visitScheduleId]="visitPlan.scheduleId"
      [branchIds]="filters.branchIds.length ? filters.branchIds : visitPlan.branchIds"
      [selectedIds]="filters.agentIds"
      (onChange)="onAgentsSelect($event.agentIds)">

    </app-visit-plan-resource-holders-multi-select>
    <div ngbDropdown container="body">
      <bringoz-button type="tertiary"
                      (click)="$event.stopPropagation();"
                      ngbDropdownToggle>
        <bringoz-icon iconName="calendar-outline"></bringoz-icon>
        <span>{{ filters.day ? (filters.day | date: 'EEEE') : (this.visitPlanRange | bringozDateRange) }}</span>
      </bringoz-button>
      <div ngbDropdownMenu aria-labelledby="action-menu">

        <button *ngFor="let day of dayOptions;"
                ngbDropdownItem
                (click)="onDayFilterSelect(day)">
          <div class="layout-row layout-align-start-center">
            <span class="br-body-2 primary-100">{{ day | date:'EEEE' }}</span>
          </div>
        </button>

      </div>
    </div>
    <bringoz-button *ngIf="filters.day"
                    type="tertiary"
                    (click)="onDayFilterSelect()">
      <bringoz-icon iconName="close-circle"></bringoz-icon>
    </bringoz-button>
    <span class="flex"></span>
    <div ngbDropdown container="body" *ngIf="selectedIds.length">
      <bringoz-button type="tertiary"
                      (click)="$event.stopPropagation();"
                      ngbDropdownToggle>
        <bringoz-icon iconName="menu"></bringoz-icon>
      </bringoz-button>
      <div ngbDropdownMenu aria-labelledby="action-menu">

        <button
          ngbDropdownItem
          (click)="onDeleteRoutes.emit(selectedIds)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="trash"
                          classSize="xl"
                          fill="#7E7E7E"
                          class="margin-right-10">

            </bringoz-icon>
            <span class="br-body-2 primary-100" translate>Delete</span>
          </div>
        </button>

        <button
          ngbDropdownItem
          (click)="onReoptimizeRoutes.emit(selectedIds)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="reoptimize"
                          classSize="xl"
                          fill="#7E7E7E"
                          class="margin-right-10">

            </bringoz-icon>
            <span class="br-body-2 primary-100" translate>Reoptimize</span>
          </div>
        </button>

      </div>
    </div>

    <bringoz-button *ngIf="!!selectedRoute"
                    type="tertiary"
                    theme="secondary"
                    [isDisabled]="!selectedJobIds?.length || visitPlan?.hasNotSyncedChanges || isSelectedRouteDayDispatched"
                    [ngbTooltip]="blockedActionTooltipKey | translate"
                    container="body"
                    openDelay="300"
                    (onClick)="onAssign.emit({ event: $event, jobIds: selectedJobIds, visitPlan })">
      <span class="br-body-1 font-weight-400">{{'Assign' | translate}} {{selectedJobIds?.length}}</span>
    </bringoz-button>

    <bringoz-button type="tertiary"
                    (onClick)="onClose.emit()"
                    [ngbTooltip]="'close' | translate"
                    openDelay="300"
                    triggers="hover"
                    aria-label="Close">
      <bringoz-icon iconName="close"></bringoz-icon>
    </bringoz-button>

  </div>
  <hr class="main-divider">
  <app-visit-plan-routes-panel-list *ngIf="!selectedRoute"
                                    class="flex"
                                    [panel]="panel"
                                    [panels]="panels"
                                    [routes]="displayedRoutes"
                                    [isLoadingRoutes]="isLoadingRoutes"
                                    [selectedIds]="selectedIds"
                                    [jobs]="jobs"
                                    [selectedJobIds]="selectedJobIds"
                                    [agentColorMap]="agentColorMap"
                                    (onMoveJobs)="onMoveJobs.emit($event)"
                                    (onDrillDown)="onRouteSelect($event)"
                                    (onSelectRoutes)="onSelectedRoutesChange.emit($event)"
                                    (onLockRouteChange)="onLockRouteChange.emit($event)"
                                    (onRoutePanelContextMenu)="onRoutePanelContextMenu.emit($event)">

  </app-visit-plan-routes-panel-list>


  <app-visit-plan-route-tasks-panel-list *ngIf="!!selectedRoute"
                                         class="flex"
                                         [panel]="panel"
                                         [route]="selectedRoute"
                                         [panels]="panels"
                                         [routes]="routes"
                                         [jobs]="jobs"
                                         [agentColorMap]="agentColorMap"
                                         [selectedJobIds]="selectedJobIds"
                                         [isLoading]="isLoading"
                                         [queryText]="queryString"
                                         [hasNotSyncedChanges]="visitPlan?.hasNotSyncedChanges"
                                         [isDayDispatched]="isSelectedRouteDayDispatched"
                                         [visitPlan]="visitPlan"
                                         [programTypeAliasMap]="programTypeAliasMap"
                                         (onEditCallServiceTime)="onEditCallServiceTime.emit($event)"
                                         (onMoveJobs)="onMoveJobs.emit($event)"
                                         (onSelect)="onRouteSelect($event)"
                                         (onSelectJobs)="onSelectJobs($event)">

  </app-visit-plan-route-tasks-panel-list>

</div>
